import { render, staticRenderFns } from "./FadeInUp.vue?vue&type=template&id=3c06f131"
import script from "./FadeInUp.vue?vue&type=script&lang=js"
export * from "./FadeInUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports